export const MultiTabsBar = {
  "confirmDialog": {
    "title": "Close request signatures",
    "Ok": "Yes",
    "Cancel": "No",
    "info": "Do you want to give up request signature?"
  }
}